module.exports = __webpack_public_path__ + "img/inventory-log-book_B09Q14944M.443e61d4.jpg";